import React, { useState, useRef } from "react";
import AlertDialog from "../components/AlertDialog";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card } from "@mui/material";
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate ,useLocation} from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import { colors } from "components/Theme/WebTheme";
import { makeStyles } from "@mui/styles";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const useStyles = makeStyles((theme) => ({
    textField: {
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    selectField: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.MAIN_COLOR,
        },
    },
    rootRtl_3: {
        "& label": {
            right: 17,
            left: "auto",
            paddingRight: 12
        },
        "& legend": {
            textAlign: "right",
            marginRight: 20
        },
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    rootRtl: {
        "& label": {
            right: 20,
            left: "auto",
            paddingRight: 20
        },
        "& legend": {
            textAlign: "right",
            marginRight: 15
        },
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    rootRtl_1: {
        "& label": {
            right: 0,
            left: "auto",
            paddingRight: 20
        },
        "& legend": {
            textAlign: "right",
            marginRight: 30
        },
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    rootRtl_2: {
        "& label": {
            right: 17,
            left: "auto",
            paddingRight: 12
        },
        "& legend": {
            textAlign: "right",
            marginRight: 25
        },
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    rootRtl_4: {
        "& label": {
            right: 17,
            left: "auto",
            paddingRight: 12
        },
        "& legend": {
            textAlign: "right",
            marginRight: 15
        },
        "& label.Mui-focused": {
            color: colors.MAIN_COLOR,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiFilledInput-underline:after": {
            borderBottomColor: colors.MAIN_COLOR,
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: colors.MAIN_COLOR,
            },
        },
    },
    selectField_rtl: {
        color: "black",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.MAIN_COLOR,
        },
        "& label": {
            right: 0,
            left: "auto",
        },
        "& legend": {
            textAlign: "right",
            marginRight: 35,
        },
    },

    right: {
        textAlign: "right",
        right: 0,
        left: "auto",
        paddingRight: 40,
    },
}));

const AddPromo = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loding, setLoding] = useState(false);
    const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
    const { editPromo } = api;
    const classes = useStyles();
    const countries = useSelector(state => state.countrylistdata.countries);
    const [data, setData] = useState({
        promo_name: "",
        promo_description: "",
        promo_discount_type: "",
        promo_code: "",
        promo_discount_value: 0,
        max_promo_discount_value: 0,
        min_order: 0,
        promo_usage_limit: 0,
        user_avail: 0,
        promo_validity: dayjs(),
    });
    const {state} = useLocation();

    const inputRef = useRef(null);

    const handleInputChange = (e) => {
        setData({ ...data, [e.target.id]: e.target.value });
    };
    const handleInputToNumberChange = (e) => {
        setData({ ...data, [e.target.id]: Number(e.target.value) });
    };

    const handleCommonAlertClose = (e) => {
        e.preventDefault();
        setCommonAlert({ open: false, msg: "" });
    };
    const handleChangePromoType = (e) => {
        setData({ ...data, promo_discount_type: e.target.value });
    };

    const handleChangeCountry = (e) => {
        setData({ ...data, country: e.target.value });
    }
    
    const handelSubmit = () => {
        new Promise((resolve, reject) => {
            setLoding(true);
            setTimeout(() => {
                // Basic validation for required fields
                if (!(data.promo_name && data.promo_code && data.promo_description && data.promo_discount_value && data.promo_discount_type && data.max_promo_discount_value && data.min_order && data.promo_usage_limit && data.country && data.promo_validity)) {
                    setLoding(false);
                    setCommonAlert({ open: true, msg: t("no_details_error") });
                    reject();
                    return;
                }

                // Validation based on promo type
                let isValid = true;
                let errorMessage = "";

                if (data.promo_discount_type === "percentage") {
                    // For percentage: promo_discount_value should be between 1-100, max_promo_discount_value should be positive
                    if (data.promo_discount_value < 1 || data.promo_discount_value > 100) {
                        isValid = false;
                        errorMessage = t("percentage_must_be_between_1_100");
                    } else if (data.max_promo_discount_value <= 0) {
                        isValid = false;
                        errorMessage = t("max_discount_must_be_positive");
                    }
                } else if (data.promo_discount_type === "flat") {
                    // For flat: promo_discount_value should be positive and not exceed max_promo_discount_value
                    if (data.promo_discount_value <= 0) {
                        isValid = false;
                        errorMessage = t("discount_value_must_be_positive");
                    } else if (data.promo_discount_value > data.max_promo_discount_value) {
                        isValid = false;
                        errorMessage = t("discount_value_cannot_exceed_max_discount");
                    }
                }

                // Common validations
                if (data.min_order <= 0) {
                    isValid = false;
                    errorMessage = t("min_order_must_be_positive");
                }

                if (!isValid) {
                    setLoding(false);
                    setCommonAlert({ open: true, msg: errorMessage });
                    reject();
                    return;
                }

                data['promo_code'] = data.promo_code.toUpperCase();
                data['promo_show'] = data.promo_show ? true : false;
                data['createdAt'] = new Date().getTime();
                data['promo_validity'] = data.promo_validity ? data.promo_validity.toDate().getTime() : null;
                dispatch(editPromo(data,"Add"));
                setLoding(false);
                navigate("/promos");
                resolve();
            }, 600);
        });
    };

    return loding ? (
        <CircularLoading />
    ) : (
        <div>
            <Card
                style={{
                    borderRadius: "19px",
                    backgroundColor: "#fff",
                    minHeight: 100,
                    maxWidth: "75vw",
                    marginTop: 20,
                    marginBottom: 20,
                    padding: 25,
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: `0px 2px 5px ${colors.SECONDARY}`,
                }}
            >
                <Typography
                    variant="h5"
                    style={{
                        marginTop: -15,
                        textAlign: isRTL === "rtl" ? "right" : "left",
                    }}
                >
                    {t("add_promo_title")}
                </Typography>
                <div
                    dir={isRTL === "rtl" ? "rtl" : "ltr"}
                >
                    <Button
                        variant="text"
                        onClick={() => {
                            navigate('/promos', { state: { pageNo: state?.pageNo }} )
                        }}
                    >
                        <Typography
                            style={{
                                marginBottom: 10,
                                textAlign: isRTL === "rtl" ? "right" : "left",
                                fontWeight: "bold",
                                color: colors.MAIN_COLOR,
                            }}
                        >
                            {`<<- ${t("go_back")}`}
                        </Typography>
                    </Button>
                </div>

                <Grid
                    container
                    spacing={2}

                    sx={{
                        gridTemplateColumns: "50%",
                        direction: isRTL === 'rtl' ? 'rtl' : 'ltr'
                    }}
                >

                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("promo_name")}
                            id="promo_name"
                            value={data.promo_name}
                            fullWidth
                            onChange={handleInputChange}
                            className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("description")}
                            id="promo_description"
                            value={data.promo_description}
                            fullWidth
                            onChange={handleInputChange}
                            className={isRTL === "rtl" ? classes.rootRtl : classes.textField}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <FormControl
                            fullWidth
                            style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                        >
                            <InputLabel
                                id="promo_discount_type"
                                className={isRTL === "rtl" ? classes.right : ""}
                                sx={{ "&.Mui-focused": { color: colors.MAIN_COLOR } }}
                            >
                                {t("type")}
                            </InputLabel>
                            <Select
                                labelId="promo_discount_type"
                                id="promo_discount_type"
                                value={data.promo_discount_type || ""}
                                label={t("type")}
                                onChange={handleChangePromoType}
                                className={
                                    isRTL === "rtl"
                                        ? classes.selectField_rtl
                                        : classes.selectField
                                }
                            >
                                <MenuItem
                                    style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                                    value={"percentage"}
                                >
                                    {t("percentage")}
                                </MenuItem>
                                <MenuItem
                                    style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                                    value={"flat"}
                                >
                                    {t("flat")}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <FormControl
                            fullWidth
                            style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                        >
                            <InputLabel
                                id="country"
                                className={isRTL === "rtl" ? classes.right : ""}
                                sx={{ "&.Mui-focused": { color: colors.MAIN_COLOR } }}
                            >
                                {t("country")}
                            </InputLabel>
                            <Select
                                labelId="country"
                                id="country"
                                value={data.country || ""}
                                label={t("country")}
                                onChange={handleChangeCountry}
                                className={
                                    isRTL === "rtl"
                                        ? classes.selectField_rtl
                                        : classes.selectField
                                }
                            >
                                {
                                    (countries ? countries : []).map((item, idx) => {
                                        return (
                                            <MenuItem
                                                style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                                                value={item.country}
                                                key={idx}
                                            >
                                                {item.country}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("promo_code")}
                            id="promo_code"
                            value={data.promo_code}
                            fullWidth
                            onChange={handleInputChange}
                            className={isRTL === "rtl" ? classes.rootRtl_2 : classes.textField}
                        />
                    </Grid>

                
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("promo_discount_value")}
                            id="promo_discount_value"
                            value={data.promo_discount_value}
                            type="number"
                            fullWidth
                            onChange={handleInputToNumberChange}
                            className={isRTL === "rtl" ? classes.rootRtl_3 : classes.textField}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("max_limit")}
                            id="max_promo_discount_value"
                            value={data.max_promo_discount_value}
                            type="number"
                            fullWidth
                            onChange={handleInputToNumberChange}
                            className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("min_limit")}
                            id="min_order"
                            value={data.min_order}
                            type="number"
                            fullWidth
                            onChange={handleInputToNumberChange}
                            className={isRTL === "rtl" ? classes.rootRtl_1 : classes.textField}
                        />
                    </Grid>

                  
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <TextField
                            label={t("promo_usage")}
                            id="promo_usage_limit"
                            value={data.promo_usage_limit}
                            type="number"
                            fullWidth
                            onChange={handleInputToNumberChange}
                            className={isRTL === "rtl" ? classes.rootRtl_4 : classes.textField}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                        <FormControl
                            fullWidth
                            style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    disablePast
                                    inputRef={inputRef}
                                    label={t("end_date")}
                                    value={data.promo_validity || dayjs()}
                                    onChange={(newValue) => {
                                        setData({
                                            ...data,
                                            promo_validity: newValue,
                                        });
                                    }}
                                    slotProps={{
                                        textField: {
                                            className: isRTL === "rtl" ? classes.rootRtl_2 : classes.textField,
                                            fullWidth: true
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Button
                            style={{
                                borderRadius: "19px",
                                backgroundColor: colors.MAIN_COLOR,
                                minHeight: 50,
                                minWidth: "50%",
                                textAlign: "center",
                                boxShadow: `0px 2px 5px ${colors.SECONDARY}`,
                            }}
                            onClick={handelSubmit}
                            variant="contained"
                        >
                            <Typography
                                style={{
                                    color: colors.WHITE,
                                    textAlign: "center",
                                    fontSize: 16,
                                }}
                            >
                                {t("submit")}
                            </Typography>
                        </Button>
                    </Grid>
                </Grid>
            </Card>
            <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
                {commonAlert.msg}
            </AlertDialog>
        </div>
    );
};

export default AddPromo;
